import React from 'react';
import PropTypes from 'prop-types';
import {
  ListItem,
  ListItemButton,
  ListItemText,
  Typography
} from '@one-thd/sui-atomic-components';
import { useShowMoreLess } from '../../../hooks/useShowMoreLess';

const NestedLinkRefinement = ({
  dimension,
  refinement
}) => {

  const { nestedRefinementsLimit } = dimension;
  const nestedRefinements = refinement.nestedRefinements || [];

  const {
    visibleItems: visibleNestedRefinements,
    toggleLabel: nestedToggleLabel,
    handleToggle: handleToggleNested,
    shouldShowToggle
  } = useShowMoreLess(nestedRefinements, nestedRefinementsLimit);

  const getRefinementId = (nestedRef, nestedRefIndex) => {
    const { refinementKey } = nestedRef;
    return `${refinementKey}-${nestedRefIndex}`;
  };

  const handleRefinementClick = (nested) => (event) => {
    event.preventDefault();
    // Use window.location to change URL
    window.location.href = nested.url;
  };

  return (
    <>
      {visibleNestedRefinements.map((nested, nestedRefIndex) => {
        const nestId = getRefinementId(nested, nestedRefIndex);
        return (
          <React.Fragment key={nested.refinementKey}>
            {/* SEO-friendly hidden link - Required for SEO significance. Reach out to SEO team if wanting to change */}
            <a
              href={nested.url}
              className="sui-hidden"
              aria-hidden="true"
              tabIndex="-1"
            >
              {/* H3 element required for SEO significance. Reach out to SEO team if wanting to change */}
              <h3>{nested.label}</h3>
            </a>
            <ListItem
              id={nestId}
            >
              <ListItemButton
                data-testid={`nested-category-refinement-${nestId}`}
                data-refinementvalue={nested.label}
                aria-label={`${nested.label}`}
                onClick={handleRefinementClick(nested)}
              >
                <ListItemText
                  primary={(
                    <Typography
                      color="primary"
                    >
                      {nested.label}
                    </Typography>
                  )}
                />
              </ListItemButton>
            </ListItem>
          </React.Fragment>
        );
      })}
      {shouldShowToggle && (
        <ListItem>
          <ListItemButton
            data-testid="nested-category-toggle-view-more"
            aria-label={nestedToggleLabel}
            onClick={handleToggleNested}
          >
            <ListItemText
              primary={nestedToggleLabel}
            />
          </ListItemButton>
        </ListItem>
      )}
    </>
  );
};

NestedLinkRefinement.propTypes = {
  dimension: PropTypes.shape({
    nestedRefinementsLimit: PropTypes.number
  }).isRequired,
  refinement: PropTypes.shape({
    label: PropTypes.string,
    refinementKey: PropTypes.string,
    nestedRefinements: PropTypes.arrayOf(
      PropTypes.shape({
        length: PropTypes.number
      })
    ),
    url: PropTypes.string
  }).isRequired
};

NestedLinkRefinement.displayName = 'NestedLinkRefinement';

export { NestedLinkRefinement };